import { InjectionToken, Signal } from '@angular/core';
import type { StepperStepComponent } from './stepper-step.component';

/** Minimal contract the child step needs from its parent stepper. */
export interface StepperParent {
  /** Currently active step index (0-based). */
  activeIndex: Signal<number>;
  /** Ordered list of projected step components, used to compute each child's index. */
  steps: Signal<readonly StepperStepComponent[]>;
}

export const STEPPER_PARENT = new InjectionToken<StepperParent>('STEPPER_PARENT');
